import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["elements", "addElement", "elementInput"]

  // Adds an element
  addedElement(event) {
    const [data, status, xhr] = event.detail
    this.elementsTarget.insertAdjacentHTML(
      "beforeend",
      JSON.parse(xhr.response).element
    )
    this.elementInputTargets.pop().focus()
    const url = new URL(this.addElementTarget.href, window.location.origin)
    const index = parseInt(url.searchParams.get("index") || "1", 10)
    url.searchParams.set("index", String(index + 1))
    this.addElementTarget.href = url.pathname + url.search
    this.element.dispatchEvent(
      new CustomEvent("offer:activity-added", { bubbles: true })
    )
  }

  // Removes an element
  removeElement(event) {
    const element = event.target.closest(".element")
    this.elementsTarget.removeChild(element)
  }
}
